import { DownOutlined, UpOutlined } from '@ant-design/icons';
import { SubscriptionTabDefinition } from '@mm/state/helpers/billing-subscription-tab-helpers';
import { EnhancedBillingPage } from '@mm/state/interfaces/connected-page';
import classNames from 'classnames';
import React, { useState } from 'react';
import { BillingPageMetadata } from './BillingPageMetadata';
import '../BillingPageCard.pcss';

type Props = {
  page: EnhancedBillingPage;
  planTab: SubscriptionTabDefinition;
};

export const BillingPageMetadataCollapser = (props: Props) => {
  const { page, planTab } = props;
  const [showMetadata, setShowMetadata] = useState(false);

  return (
    <div className="billing-page-metadata-collapser">
      <div
        className={classNames('billing-page-card__metadata-collapser', {
          'billing-page-card__metadata-collapser-expanded': showMetadata,
        })}
        onClick={() => setShowMetadata(!showMetadata)}
      >
        {showMetadata ? <UpOutlined /> : <DownOutlined />}
        {showMetadata ? 'Collapse' : 'Show details'}{' '}
      </div>
      {showMetadata && <BillingPageMetadata page={page} planTab={planTab} />}
    </div>
  );
};
